import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.v6.V6QuoteSupplierGlassView.';
  public static readonly readonlyIguWhenItemEditing = `${Id.prefix}readonlyIguWhenItemEditing`;
  public static readonly supplierServiceNotAvailable = `${Id.prefix}supplierServiceNotAvailable`;
  public static readonly addQuoteIgu = `${Id.prefix}addQuoteIgu`;
}

export class LangV6QuoteSupplierGlassView {
  private constructor() {}
  public static readonlyIguWhenItemEditing(): string {
    return interpolate(Id.readonlyIguWhenItemEditing);
  }
  public static supplierServiceNotAvailable(): string {
    return interpolate(Id.supplierServiceNotAvailable);
  }
  public static addQuoteIgu(): string {
    return interpolate(Id.addQuoteIgu);
  }
}

export class V6QuoteSupplierGlassViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.readonlyIguWhenItemEditing,
      "{{glossary 'quote-igu:plural'}} are readonly when {{glossary 'quote-item:plural'}} are being edited",
      'Alert message when IGUs are readonly due to quote items being edited'
    );
    register.add(
      Id.supplierServiceNotAvailable,
      "{{glossary 'supplier'}} service not available",
      'Message shown when supplier service is not available'
    );
    register.add(Id.addQuoteIgu, "Add {{glossary 'quote-igu'}}", 'Button label for adding a quote IGU');
  }
}
